<script>
  import { link, navigate } from "svelte-routing";
  import { writable } from 'svelte/store';
  import pb from '../../lib/pocketbase'; // Importación del cliente PocketBase
  import { onMount } from 'svelte';

  const google = "../assets/img/google.svg";
  const companyLogo = "/assets/images/abindustrial_logo.png"; // Path to AB Industrial logo
  const companyName = "AB Industrial, S.A.";
  
  let email = '';
  let password = '';
  let rememberMe = false;
  const error = writable(null);

  onMount(() => {
    // Fetch random Flickr background
    const apiKey = "7728c3c0ec5332a339b1e89666a4d2ed";
    fetch(`https://api.flickr.com/services/rest/?method=flickr.photosets.getPhotos&api_key=${apiKey}&photoset_id=72177720302447704&user_id=130115410%40N08&format=json&nojsoncallback=1`)
      .then(response => response.json())
      .then(data => {
        const index = Math.floor(Math.random() * data.photoset.photo.length);
        const photo = data.photoset.photo[index];
        const bgURL = `url(https://farm${photo.farm}.staticflickr.com/${photo.server}/${photo.id}_${photo.secret}_b.jpg)`;
        document.body.style.backgroundImage = bgURL;
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center center';
        document.body.style.backgroundAttachment = 'fixed';
        document.body.style.backgroundRepeat = 'no-repeat';
      });
  });

  // Función para iniciar sesión con email y contraseña
  async function handleSubmit(event) {
    event.preventDefault();
    
    if (!email || !password) {
      error.set("Por favor, completa todos los campos.");
      return;
    }

    try {
      const authData = await pb.collection('users').authWithPassword(email, password);

      // Guardar token y usuario autenticado
      localStorage.setItem('pb_token', pb.authStore.token);
      localStorage.setItem('pb_user', JSON.stringify(pb.authStore.model));
      
      // Set token expiration based on remember me
      if (rememberMe) {
        // Set longer expiration for remember me (30 days)
        pb.authStore.save(pb.authStore.token, pb.authStore.model, { expires: 30 * 24 * 60 * 60 });
      } else {
        // Set shorter expiration for normal login (1 day)
        pb.authStore.save(pb.authStore.token, pb.authStore.model, { expires: 24 * 60 * 60 });
      }

      navigate('/admin/dashboard');  // Redirige al dashboard
    } catch (err) {
      error.set(err.message || 'Error al iniciar sesión');
    }
  }

  // Función para iniciar sesión con Google OAuth
  async function handleGoogleLogin() {
    try {
      const authData = await pb.collection('users').authWithOAuth2({ provider: 'google' });

      // Guardar token y usuario autenticado
      localStorage.setItem('pb_token', pb.authStore.token);
      localStorage.setItem('pb_user', JSON.stringify(pb.authStore.model));

      const userName = authData.meta.rawUser.name;

      // Actualizar el usuario en la colección si es necesario
      await pb.collection('users').update(pb.authStore.model.id, { name: userName });

      console.log("Nombre de usuario guardado:", userName);

      navigate('/admin/dashboard');  // Redirige al dashboard
    } catch (err) {
      error.set("Error durante el inicio con Google: " + (err.message || ''));
    }
  }
</script>

<div class="container mx-auto px-4 h-full">
  <div class="flex content-center items-center justify-center h-full">
    <div class="w-full lg:w-4/12 px-4">
      <div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200 border-0 bg-opacity-90">
        <!-- Logo Section -->
        <div class="flex justify-center items-center py-8 px-4">
          <div class="text-center">
            <div class="mb-4">
              <div class="inline-block p-4 bg-white rounded-full shadow-lg transform hover:scale-105 transition-transform duration-300">
                <img
                  src={companyLogo}
                  alt={companyName}
                  class="h-16 w-16 object-contain"
                />
              </div>
            </div>
            <div class="mb-2">
              <h1 class="text-2xl font-bold text-blueGray-800 mb-1">{companyName}</h1>
              <p class="text-sm text-blueGray-600 font-medium">Sistema de Gestión Empresarial</p>
            </div>
          </div>
        </div>

        <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
          <div class="text-blueGray-400 text-center mb-3 font-bold">
            <small>Inicia sesión con tus credenciales</small>
          </div>
          <form on:submit={handleSubmit}>
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-email">
                Correo Electrónico
              </label>
              <input
                id="grid-email"
                type="email"
                bind:value={email}
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Correo Electrónico"
              />
            </div>

            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Contraseña
              </label>
              <input
                id="grid-password"
                type="password"
                bind:value={password}
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder="Contraseña"
              />
            </div>

            <div>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  id="customCheckLogin"
                  type="checkbox"
                  bind:checked={rememberMe}
                  class="form-checkbox border-0 rounded text-blueGray-700 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                />
                <span class="ml-2 text-sm font-semibold text-blueGray-600">
                  Recuérdame
                </span>
              </label>
            </div>

            <div class="text-center mt-6">
              <button
                class="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                type="submit"
              >
                Iniciar Sesión
              </button>
            </div>

            {#if $error}
              <div class="text-red-500 text-sm mt-2">{ $error }</div>
            {/if}
          </form>
        </div>
      </div>
      <div class="flex flex-wrap mt-6 relative">
        <div class="w-1/2">
          <a href="#erpsys" on:click={(e) => e.preventDefault()} class="text-blueGray-200">
            <small>¿Olvidaste tu contraseña?</small>
          </a>
        </div>
        <div class="w-1/2 text-right">
          <a use:link href="/auth/register" class="text-blueGray-200">
            <small>Crear nueva cuenta</small>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
